// Flash-сообщения Rails (notice, alert) как всплывающие уведомления — по одному: новое заменяет
// текущее. Inertia шлёт событие flash на каждый ответ, где они есть, — в том числе при первой
// загрузке и при повторе того же текста.
// Подписка — при импорте модуля (до createInertiaApp), иначе flash первой страницы потеряется.
import { reactive } from "vue"
import { router } from "@inertiajs/vue3"

const LIFETIME = { notice: 2600, alert: 10000 }

export const toasts = reactive([])
let nextId = 1

export function dismissToast(id) {
  const index = toasts.findIndex((toast) => toast.id === id)
  if (index !== -1) toasts.splice(index, 1)
}

export function showToast(type, text) {
  const id = nextId++
  toasts.splice(0, toasts.length, { id, type, text })
  setTimeout(() => dismissToast(id), LIFETIME[type] ?? LIFETIME.notice)
}

router.on("flash", (event) => {
  const { notice, alert } = event.detail.flash
  // Если пришли оба — остаётся ошибка.
  if (notice) showToast("notice", notice)
  if (alert) showToast("alert", alert)
})
